<template>
  <Intro textContent="Memories<br>since 2017" imageFileName="bera.jpg" imageAlt="魚の鱗" />
  <div class="album-container-bg">
    <div class="albums-flex">
      <div v-for="album in albums" :key="album.id" class="each-content-wrapper">
        <router-link :to="{ name: 'GalleryDetail', params: { folder: album.folder } }" class="album-outline">
          <div class="texts-wrapper">
            <div class="album-text-ja">
              <p>{{ album.textJa }}</p>
            </div>
            <div class="album-text">
              <h3>{{ album.textEn }}</h3>
            </div>
            <div class="album-subtext">
              <p>{{ album.subtext }}</p>
            </div>
          </div>
          <figure class="dot-img"><img :src="album.image" :alt="album.alt" /></figure>
          <div class="explore-touch-effect">
            <img src="@/assets/img/gallery/touchEffectLoop.gif" alt="Touch Effect" />
            <span class="span-explore-text">Explore</span>
          </div>
          <div class="book-left-shadow"></div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import Intro from '@/features/common/Intro.vue';

export default {
  name: "AlbumGallery",
  components: {
    Intro,
  },
  data() {
    return {
      albums: [
        {
          id: "scenery",
          folder: "scenery",
          textJa: "景色",
          textEn: "Scenery",
          subtext: "Nature photos: ocean, mountains, stars, sunsets, etc.",
          image: require('@/assets/img/gallery/gallery110.jpg'),
          alt: "伊豆大島の海",
        },
        {
          id: "fishing",
          folder: "fishing",
          textJa: "釣り",
          textEn: "Fishing",
          subtext: "Fishing photos: ocean fishing, fish, cooking, etc.",
          image: require('@/assets/img/gallery/gallery149.jpg'),
          alt: "伊豆大島での釣り",
        },
        {
          id: "villa",
          folder: "villa",
          textJa: "別荘計画",
          textEn: "Villa",
          subtext:
            "Photos of the villa project: land search, inspection, planning process, etc.",
          image: require('@/assets/img/gallery/gallery137.jpg'),
          alt: "伊豆大島の別荘",
        },
        {
          id: "meeting",
          folder: "meeting",
          textJa: "集い",
          textEn: "Meeting",
          subtext:
            "Photos of gatherings for planning, website development, play, etc.",
          image: require('@/assets/img/gallery/gallery176.jpg'),
          alt: "伊豆大島の集まり",
        },
        {
          id: "all",
          folder: "All",
          textJa: "すべて",
          textEn: "All",
          subtext: "All photos so far",
          image: require('@/assets/img/gallery/gallery97.jpg'),
          alt: "伊豆大島の夕焼け",
        },
      ],
    };
  },
};
</script>

<style scoped>
.album-container-bg {
  position: relative;
  margin-top: 100px;
  margin-bottom: 100px;
  height: auto;
  width: 80%;
  top: 0;
  left: 20%;
  background: linear-gradient(to bottom right, rgba(255, 253, 250, 0.919), rgba(229, 226, 221, 0.8)), url(@/assets/img/gallery/bg_noise_2.png);
  z-index: 0;
}

.albums-flex {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 100px;
}

.albums-flex .each-content-wrapper:first-child {
  margin-top: 130px;
}

.albums-flex .each-content-wrapper:last-child {
  margin-bottom: 130px;
}

.each-content-wrapper {
  display: flex;
  flex-direction: row-reverse;
  width: 100%;
  height: auto;
  gap: 100px;
  z-index: 1;
}

.album-outline {
  position: relative;
  width: 548px;
  min-width: 500px;
  height: 650px;
  margin-right: 14%;
  background: -webkit-linear-gradient(112deg, rgb(255, 253, 252), rgb(237, 235, 232));
  background: linear-gradient(112deg, rgb(255, 254, 253), rgb(238, 236, 233));
  box-shadow:
    1.2px 1.4px 2.2px rgba(0, 0, 0, 0.037),
    2.9px 3.3px 5.3px rgba(0, 0, 0, 0.053),
    5.5px 6.1px 10px rgba(0, 0, 0, 0.065),
    9.8px 10.9px 17.9px rgba(0, 0, 0, 0.077),
    18.4px 20.5px 33.4px rgba(0, 0, 0, 0.093),
    44px 49px 80px rgba(0, 0, 0, 0.13);
  border-top: 1.5px solid #ffffff;
  border-left: 1px solid #ffffff;
  border-right: 1.5px solid #c9c9c9;
  border-bottom: 1.5px solid #c9c9c9;
  border-radius: 3px;
  transition: transform 0.4s;
}

.album-outline:hover {
  transform: scale(1.01);
}

.texts-wrapper {
  position: absolute;
  top: 2rem;
  left: 4rem;
  z-index: 3;
  opacity: 0.95;
}

.album-text-ja {
  font-size: 12px;
  font-weight: 300;
  color: #4d4d4d;
  font-family: sans-serif;
}

.album-text {
  margin-top: 80px;
  font-size: 20px;
  font-family: "copse";
  color: #484646;
}

.album-subtext {
  font-size: 13px;
  font-family: "copse";
  transform: translateY(-15px);
  color: #4d4d4d;
}

.dot-img {
  z-index: 2;
}

.dot-img::before {
  content: "";
  background-image: radial-gradient(#232946 69%, #fff 70%);
  background-size: 3px 3px;
  opacity: .10;
  /* 透明度 */
  z-index: 3;
  position: absolute;
  top: 279px;
  right: 9%;
  width: 80%;
  height: 280px;
}

.album-outline img {
  position: absolute;
  top: 279px;
  right: 9%;
  width: 80%;
  height: 280px;
  object-fit: cover;
  border-radius: 1%;
  filter: contrast(90%) saturate(80%) opacity(98%);
  z-index: 2;
}

.explore-touch-effect {
  position: absolute;
  right: 10%;
  bottom: 15%;
  width: 130px;
  height: 130px;
  -webkit-tap-highlight-color: transparent;
  /* スマホでのタップ時のハイライトを無効化 */
  z-index: 4;
}

.explore-touch-effect img {
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  height: 100%;
  opacity: 0.6;
  box-shadow: none;
}

.span-explore-text {
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  position: absolute;
  text-align: center;
  font-size: 12px;
  font-family: sans-serif;
  font-weight: normal;
  color: rgba(255, 255, 255, 0.9);
  animation: blink-animation 3s infinite;
}

@keyframes blink-animation {
  0% {
    opacity: 0.8;
  }

  50% {
    opacity: 0.4;
  }

  100% {
    opacity: 0.8;
  }
}

.book-left-shadow {
  position: absolute;
  top: 50%;
  left: 3%;
  transform: translate(-50%, -50%);
  width: 20px;
  height: 650px;
  background: linear-gradient(to right, rgba(218, 218, 218, 0.005) 0%, rgba(154, 156, 156, 0.3) 20%, rgba(219, 220, 220, 0.01) 80%, rgba(221, 223, 223, 0.001) 100%);
  z-index: 2;
}

/* タブレット、スマートフォン向けのスタイル */
@media screen and (max-width: 570px) {
  .album-container-bg {
    margin-top: 70px;
    margin-bottom: 40px;
    background: linear-gradient(to bottom right, rgba(255, 254, 254, 0.919), rgba(240, 237, 233, 0.8)), url(@/assets/img/gallery/bg_noise_2.png);
  }

  .albums-flex {
    gap: 30px;
  }

  .albums-flex .each-content-wrapper:first-child {
    margin-top: 50px;
  }

  .albums-flex .each-content-wrapper:last-child {
    margin-bottom: 50px;
  }

  .each-content-wrapper {
    width: 100%;
    height: auto;
    gap: 30px;
    transform: scale(0.95);
  }

  .album-outline {
    width: 300px;
    min-width: 350px;
    height: 420px;
    margin-right: 6%;
    box-shadow:
      1.2px 1.4px 2.2px rgba(96, 96, 96, 0.037),
      2.9px 3.3px 5.3px rgba(119, 119, 119, 0.053),
      5.5px 6.1px 10px rgba(106, 106, 106, 0.065),
      9.8px 10.9px 17.9px rgba(83, 83, 83, 0.077),
      18.4px 20.5px 33.4px rgba(86, 86, 86, 0.093),
      44px 49px 80px rgba(49, 49, 49, 0.13);
  }

  .book-left-shadow {
    top: 50%;
    left: 3%;
    transform: translate(-50%, -50%);
    width: 14px;
    height: 420px;
  }

  .texts-wrapper {
    top: 1.5rem;
    left: 2.5rem;
    z-index: 3;
    opacity: 0.95;
  }

  .album-text-ja {
    font-size: 9px;
    font-weight: 300;
  }

  .album-text {
    margin-top: 40px;
    font-size: 14px;
  }

  .album-subtext {
    font-size: 10px;
    margin-right: 30px;
  }

  .dot-img::before {
    top: 165px;
    height: 190px;
    background-image: radial-gradient(#493823 69%, #fff 70%);
    background-size: 2px 2px;

  }

  .album-outline img {
    top: 165px;
    height: 190px;
  }

  .explore-touch-effect {
    width: 100px;
    height: 100px;
    right: 10%;
    bottom: 15%;
  }

  .explore-touch-effect img {
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 90%;
    height: 90%;
  }

}
</style>
